import React, { useEffect, useState } from "react";
import MovedModal from "./MovedModal";

const SpecialsButton = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleClick = () => {
    setIsModalOpen(true);
  };

  useEffect(() => {
    if (!sessionStorage.getItem("MOVING_MODAL")) {
      sessionStorage.setItem("MOVING_MODAL", "true");
      setIsModalOpen(true);
    }
  }, []);

  const hasReopened = Date.now() >= new Date("2026-05-20").getTime();

  return (
    <>
      <button className="specials-button-full " onClick={handleClick}>
        {hasReopened ? "WE HAVE REOPENED!" : "OFFICE RELOCATION"}
      </button>
      <MovedModal
        show={isModalOpen}
        handleClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default SpecialsButton;
